export const carBookingProgressSelector = state => state.carBookingProgress;
